(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-atc-bar"]) return;
  try {
    
  customElements.whenDefined('sticky-atc-bar').then(function () {
    var Ctor = customElements.get('sticky-atc-bar');
    if (!Ctor || Ctor.prototype.__imageSwapPatched) return;
    Ctor.prototype.__imageSwapPatched = true;

    var proto = Ctor.prototype;
    var originalUpdatePrice = proto.updatePrice;

    // Reutilizamos updatePrice porque se llama en AMBOS flujos
    // (cambio desde el sticky y pubsub variantChange del producto principal),
    // siempre después de fijar this.currentVariant.
    proto.updatePrice = function () {
      if (originalUpdatePrice) originalUpdatePrice.apply(this, arguments);
      try { this.updateFeaturedImage(); } catch (e) {}
    };

    proto.updateFeaturedImage = function () {
      var wrap = this.querySelector('.sticky-atc-bar__product-image');
      var img = wrap && wrap.querySelector('img');
      if (!img) return;

      var id = (this.currentVariant && this.currentVariant.id) ||
               Number(this.querySelector('[name="id"]').value);

      // Buscamos en el JSON propio del sticky (no en event.data.variant),
      // porque ese payload puede no traer featured_image.
      var data = this.getVariantData();
      var variant = data && data.find(function (v) { return v.id === Number(id); });
      if (!variant || !variant.featured_image) return; // variante sin imagen propia -> conserva la actual

      var src = variant.featured_image.src;
      if (src.indexOf('//') === 0) src = 'https:' + src;
      src = src.split('?')[0] + '?width=180';

      if (img.currentSrc && img.currentSrc.split('?')[0] === src.split('?')[0]) return;

      img.removeAttribute('srcset');     // sin esto el srcset 90w/180w pisa el src nuevo
      img.removeAttribute('data-srcset');
      if (img.hasAttribute('data-src')) img.setAttribute('data-src', src);
      img.src = src;
    };
  });

  } catch(e) { console.error(e); }
})();
})();
